import React, { type HTMLAttributes } from 'react';
import cx from 'classnames';
import stylesheet from './Menu.css';

export type MenuProps = {
  /** Consumes `MenuItem` components */
  children?: React.ReactNode;
  /** Determines whether the menu has a max-height*/
  fullHeight?: boolean;
  /** Determines the size of the menu */
  size?: 'small' | 'medium';
} & HTMLAttributes<HTMLDivElement>;

const Menu = React.forwardRef<HTMLDivElement, MenuProps>(function Menu(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  { children, fullHeight, size = 'small', ...props },
  menuRef,
) {
  return (
    <div
      className={cx(
        stylesheet.menu,
        fullHeight && stylesheet.fullHeight,
        size && stylesheet[size],
      )}
      ref={menuRef}
      {...props}
    >
      {children}
    </div>
  );
});

export { Menu as default };
